const getInteractionDisplayType = ({ interactionType, sourceCrmEmailId }) =>
  interactionType === 'Email' ? (sourceCrmEmailId ? 'Email campaign' : 'Email') : interactionType;

export default getInteractionDisplayType;
